import { css } from 'styled-components'

export const breakpoints = {
	desktopWide: 1440,
	desktop: 1280,
	tablet: 1024,
	phone: 768,
}

export const biggerThan = Object.keys(breakpoints).reduce((accumulator, label) => {
	accumulator[label] = (...args) => css`
		@media (min-width: ${breakpoints[label]}px) {
			${css(...args)};
		}
	`
	return accumulator
}, {})

export const smallerThan = Object.keys(breakpoints).reduce((accumulator, label) => {
	accumulator[label] = (...args) => css`
		@media (max-width: ${breakpoints[label] - 1}px) {
			${css(...args)};
		}
	`
	return accumulator
}, {})
